import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import IStatusPage from 'features/statusPage/model/StatusPage/IStatusPage';

import StatusPageForm from './StatusPageForm/StatusPageForm';

interface IStatusPageModalProps {
    open: boolean;
    item?: IStatusPage;
    handleClose: () => void;
}

const StatusPageModal: React.FC<IStatusPageModalProps> = ({open, item, handleClose}) => {
    const isNew = !item;

    return (
        <MainModal
            header={isNew ? t`Создание страницы статуса` : t`Редактирование страницы статуса`}
            open={open}
            handleClose={handleClose}
            size="md"
        >
            {open && (
                <StatusPageForm
                    uuid={item?.uuid}
                    onSuccess={handleClose}
                    onClose={handleClose}
                />
            )}
        </MainModal>
    );
};

export default StatusPageModal;
